import React, {FC} from 'react';

import {Anchor} from '../../../../../libs/shared/ui/src/components/reposition/repositionHelpers';
import {SandboxScenariosEnum} from '../../../../helpers/sandbox/sandboxScenarioHelpers';
import {ChatIntroEducationTip} from './chatIntroEducationTip';
import {SandboxEducationTipCoordinator} from './sandboxEducationTipCoordinator';

/*
 * Props.
 */

interface ChatIntroEducationTipCoordinatorProps {
  anchor: Anchor;
  conversationId: number | undefined;
}

/*
 * Component.
 */

export const ChatIntroEducationTipCoordinator: FC<ChatIntroEducationTipCoordinatorProps> = (props) => (
  <SandboxEducationTipCoordinator
    anchor={props.anchor}
    conversationId={props.conversationId}
    scenario={SandboxScenariosEnum.SCENARIO3_ACT4}
    step="start-scenario-3-conversation-4"
    isEligible
    EducationTip={ChatIntroEducationTip}
  />
);
